import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { getStatusLabel, IStatusMetrics, statusesColors } from 'interfaces/dashboard';
import React, { memo } from 'react';
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

import Card from '../Component/Card';

interface IProps {
  label: string;
  metrics: IStatusMetrics[];
  onClick: () => void;
}

const useStyles = makeStyles(theme => ({
  actionArea: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    height: '100%',
    overflow:'hidden'
  },
  content: {
    alignSelf: 'center'
  },
  middleText: theme.typography.h5,
  iconStatus: {
    verticalAlign: 'middle'
  },
  label: {
    fontWeight: 'bold',
  }
}));

const StatusesBar = memo<IProps>((props) => {
  const { metrics, label, onClick } = props;
  const classes = useStyles();
  const labelFormatter = (name: string) => getStatusLabel(name, true);
  const formatter = (name: number) => [name];

  return (
    <CardActionArea onClick={onClick} className={classes.actionArea}>
      <Card bgContent padding={0}>
        <Grid container spacing={2}>
          <Grid item xs className={classes.content}>
            <Typography className={classes.label} variant='body1' align='center'>
              {label}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ResponsiveContainer width='100%' height={120}>
              <BarChart className={classes.label} data={metrics} margin={{ top: 20 }}>
                <Tooltip labelFormatter={labelFormatter} formatter={formatter} cursor={{ radius: 8, opacity: 0.25 }} />
                <Bar
                  dataKey="value"
                  background={false}
                  fill="#8884d8"
                  label={{ position: 'top' }}
                  radius={6}
                >
                  {metrics.map((entry) => (
                    <Cell
                      key={`cell-${entry.status}`}
                      fill={statusesColors[entry.status]}
                    />
                  ))}
                </Bar>
                <XAxis dataKey="status" hide />
              </BarChart>
            </ResponsiveContainer>
          </Grid>
        </Grid>
      </Card>
    </CardActionArea>
  );
});

export default StatusesBar;